import React, { useState } from "react";
import { HiOutlineCog } from "react-icons/hi";
import SidePanelContent from "./SIdePanelContent";
import { Drawer } from "@mui/material";

function Sidepanel() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        className="w-10 h-10 sm:w-12 sm:h-12 rounded-full text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 focus:outline-none flex items-center justify-center"
        onClick={() => setIsOpen(true)}
        title="Settings"
        aria-label="Settings"
      >
        <HiOutlineCog className="w-5 h-5" />
      </button>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: "300px",
            backgroundColor: "transparent",
            boxShadow: "none",
          },
          "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0, 0, 0, 0.4)",
          },
        }}
      >
        <SidePanelContent setIsOpen={setIsOpen} />
      </Drawer>
    </>
  );
}

export default Sidepanel;
